import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);

  return next(req).pipe(
    catchError((error: { status?: number }) => {
      if (error.status === 401) {
        authService.logout();
      }
      // Toast is handled by ApiService based on showToaster option — do not duplicate here
      return throwError(() => error);
    })
  );
};
